import { useContext, useEffect } from "react";
import SocketStore from "../../stores/SocketStore";
import CallStore from "../../stores/CallStore";
import { ModalAlertContext } from "../../contexts/ModalAlertContext";
import { observer } from "mobx-react";
import ChatStore from "../../stores/ChatStore";
import strings from "../../localization";

const EndCallByCustomerForTech = ({ client }) => {
  const { isOpenEndCallByCustomerForTech } = CallStore;

  useEffect(() => {
    if (!isOpenEndCallByCustomerForTech) return;

    CallStore.setTechEndCallModal(true)

  }, [isOpenEndCallByCustomerForTech]);

  return null;
};

export default observer(EndCallByCustomerForTech);